import EventDispatcher from "js-class.event-dispatcher"; // Generic Event dispatcher
import shadowCSS from 'bundle-text:./shadow.scss' // load stylesheet inline for shadow dom injection
import Language from './elements/Language.js';
import Source from './elements/Source.js';
import Setting from './elements/Setting.js';
import Preview from './elements/Preview.js';

(function(){
	class hapVideoAdmin extends HTMLElement {
		connectedCallback() {
			this.events = new EventDispatcher(this);
			this.shadow = this.attachShadow({mode: 'open'});
			this.param = {};
			this.hapidam = false;

			try { this.param = JSON.parse(this.getAttribute('params')); }
			catch(e) { this.param = {}; }
			if(!this.param || !typeof this.param === 'object' || typeof this.param.valueOf !== 'function') this.param = {};

			this.currentLanguage = null;

			this.root = null;
			this.dom = {};

			let param = this.getParam();

			this.elements = {
				language: new Language({
					param:this.param,
					languages: JSON.parse(this.getAttribute('languages')),
					selected: this.getAttribute('language'),
				}),
				source: new Source(param),
				setting: new Setting(param),
				preview: new Preview(param)
			};

			this.elements.language.on('change',() => {
				this.currentLanguage = this.elements.language.getLanguage();
				this.difuseParams();
			})

			this.elements.source.on('change',() => {
				this.setParam(this.elements.source.getParam());
				this.difuseParams();
			})

			this.elements.setting.on('change',() => {
				this.setParam(this.elements.setting.getParam());
				this.difuseParams();
			})

			this.dom__init();

			if(this.getAttribute('hapidam-token'))
			{
				this.hapidam= {
					token: this.getAttribute('hapidam-token'),
					endpoint: this.getAttribute('hapidam-endpoint') || 'https://hapidam.com',
					client: null,
				}

				if(typeof Hapidam !== 'function') {
					var script = document.createElement('script')
					script.setAttribute('src',this.hapidam.endpoint+"/client.js");
					this.root.appendChild(script);
				}

				setTimeout(() => {
					try {
						this.hapidam.client = new Hapidam({token:this.hapidam.token, baseURL: this.hapidam.endpoint});
						this.elements.source.setHapidam(this.hapidam.client);
					}
					catch(e) {
						// nothing to do ...
					}
				},1000);
			}
		}

		on(eventName,callback) { this.events.registerEvent(eventName,callback); }
		off(eventName,callback) { this.events.unregisterEvent(eventName,callback); }
		fire(eventName,data) { this.events.fireEvent(eventName, data); }

		difuseParams() {
			// language element need the full i18n parameters
			// (used to display a "set" indicator)
			this.elements.language.loadParam(this.param);
			// other interface element just need localized parameters
			let params = {...this.getParam()};
			this.elements.source.loadParam(params);
			this.elements.preview.loadParam(params);
			this.elements.setting.loadParam(params);
		}

		setParam(k,v=null)
		{
			if(this.currentLanguage)
			{
				this.param.i18n = this.param.i18n || {};
				this.param.i18n[this.currentLanguage] = this.param.i18n[this.currentLanguage] || {};

				if(typeof k === 'string')
					this.param.i18n[this.currentLanguage][k] = v;
				else
					this.param.i18n[this.currentLanguage] = k;
			}
			else
			{
				if(typeof k === 'string')
					this.param[k] = v;
				else
				{
					//let i18n = {...this.param.i18n};
					this.param = k;
					//this.param.i18n = i18n;
				}
			}
			this.dom__refresh()

			let params = JSON.stringify(this.param)
			this.setAttribute('params',params)
			this.fire('change',params)
		}
		getParam(k=null)
		{
			if(k)
			{
				if(this.currentLanguage)
				{
					return this.param.i18n && this.param.i18n[this.currentLanguage] ? this.param.i18n[this.currentLanguage][k] : undefined;
				}
				return this.param[k] || undefined;
			}
			else
			{
				if(this.currentLanguage)
				{
					return this.param.i18n ? this.param.i18n[this.currentLanguage]  : undefined;
				}
				return this.param || undefined;
			}
		}

		dom__init() {
			this.shadow.innerHTML = `
				<style>${shadowCSS}</style>
				<div class="root" part="root" loading>
					<div part="language"></div>
					<div part="source"></div>
					<div part="setting"></div>
					<div part="preview"></div>
				</div>
			`;
			this.root = this.shadow.querySelector('.root');

			// elements injection
			for(let i in this.elements)
			{
				this.root.querySelector(`[part="${i}"]`).appendChild(this.elements[i].dom);
			}

			this.dom__refresh()
		}

		dom__refresh() {
			for(let i in this.elements)
			{
				this.elements[i].dom__refresh();
			}
		}

		disconnectedCallback() {
			// on HTMLElement dismount
		}
	}
	customElements.define('hapi-video-admin', hapVideoAdmin);
})()